import { cx } from "@emotion/css";
import Skeleton from "@mui/material/Skeleton";
import { useTranslation } from "react-i18next";

const SKELETON_ROWS = ["user", "bot", "user", "bot"] as const;

export const ChatbotMessageListSkeleton = () => {
	const { t } = useTranslation();

	return (
		<div
			className="chatbot-message-list"
			role="status"
			aria-busy="true"
			aria-label={t(
				"globalChatbot.loadingConversation",
				"Ładowanie rozmowy...",
			)}
			data-test-id="chatbot-message-list-skeleton"
		>
			{SKELETON_ROWS.map((author, index) => (
				<div
					key={index}
					className={cx("chatbot-message-row", {
						"chatbot-message-row--user": author === "user",
					})}
				>
					<Skeleton
						variant="rounded"
						className={cx("chatbot-bubble-skeleton", {
							"chatbot-bubble-skeleton--user": author === "user",
						})}
					/>
				</div>
			))}
		</div>
	);
};
